import { configureStore } from '@reduxjs/toolkit';
import { checkLogin } from './auth-actions';
import { checkWindowSize } from './responsive-action';
import authSlice from './auth-slice';
import gamificationSlice from './gamification-slice';
import responsiveSlice from './responsive-slice';
import translateSlice from './translate-slice';
import assessmentsSlice from './assessments-slice';
import generalSlice from './general-slice';
import chatSlice from './chatAi-slice';

const store = configureStore({
    reducer: {
        gamification: gamificationSlice.reducer,
        auth: authSlice.reducer,
        responsive: responsiveSlice.reducer,
        translate: translateSlice.reducer,
        assessments: assessmentsSlice.reducer,
        general: generalSlice.reducer,
        chat: chatSlice.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    })
});

export default store;
store.dispatch(checkLogin());
store.dispatch(checkWindowSize());


